import { render, staticRenderFns } from "./AuthorizedDialog.vue?vue&type=template&id=006062bc&scoped=true"
import script from "./AuthorizedDialog.vue?vue&type=script&lang=js"
export * from "./AuthorizedDialog.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedDialog.vue?vue&type=style&index=0&id=006062bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006062bc",
  null
  
)

export default component.exports